module.exports = __webpack_public_path__ + "static/media/medical_expenses.6cf527d1.svg";